import { useContext, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Toaster } from 'react-hot-toast'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { MODALS_ID } from '../../constants'

import { StoresContext } from '../../provider/StoreProvider'
import { ModalContext } from '../../provider/ModalProvider'
import { BottomSheetContext } from '../../provider/BottomSheetProvider'

import { BottomSheet } from '../bottomSheet'
import { Modals } from '../modal'
import { Spinner } from '../spinner/Spinner'
import { RendingModal } from '../../pages/home/modals/RendingModal'
import { RendingBottomSheet } from '../../pages/home/bottomSheet/RendingBottomSheet'

export const GlobalComponents = observer(() => {
  const {
    commonStore: { isLoading },
  } = useContext(StoresContext)

  // Rending Modal
  // const { openModal } = useContext(ModalContext)

  // useEffect(() => {
  //   const Yes24LoginRendingModalExpired = localStorage.getItem('Yes24LoginRendingModalExpired')

  //   if (!Yes24LoginRendingModalExpired || dayjs().diff(dayjs(Yes24LoginRendingModalExpired), 'days') >= 6) {
  //     openModal({ id: MODALS_ID.RENDING, Component: RendingModal })
  //   }
  // }, [])

  // Rending BottomSheet
  // const { showBottomSheet } = useContext(BottomSheetContext)

  // useEffect(() => {
  //   const secondProductYes24EventBottomSheetExpired = localStorage.getItem('SecondProductYes24EventBottomSheetExpired')

  //   if (
  //     !secondProductYes24EventBottomSheetExpired ||
  //     dayjs().diff(dayjs(secondProductYes24EventBottomSheetExpired), 'days') > 0
  //   ) {
  //     showBottomSheet({
  //       Component: () => <RendingBottomSheet />,
  //     })
  //   }
  // }, [])

  useEffect(() => {
    localStorage.removeItem('Yes24LoginRendingModalExpired')
    localStorage.removeItem('SecondProductYes24EventBottomSheetExpired')
  }, [])

  return (
    <>
      <BottomSheet.Render />
      <Modals />
      <Toaster containerStyle={{ position: 'absolute', bottom: 0, zIndex: 22000 }} />
      {isLoading && (
        <LoadingContent className="custom-loadable">
          <Spinner />
        </LoadingContent>
      )}
    </>
  )
})

const LoadingContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
  height: 100%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
`
